/* Homepage Hero controller and helpers. */
(function () {
  'use strict';
  if (window.__lumosHeroSections) return;

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  var Responsive = /*#__PURE__*/function () {
    function Responsive() {
      var _this = this;

      _classCallCheck(this, Responsive);

      this.currentBreakpoint = Responsive.getCurrentBreakpoint();
      window.addEventListener('resize', function () {
        var newBreakpoint = Responsive.getCurrentBreakpoint();

        if (_this.currentBreakpoint === newBreakpoint) {
          return;
        }

        document.dispatchEvent(new CustomEvent('lumos-hero:breakpoint', {
          detail: {
            previousBreakpoint: _this.currentBreakpoint,
            currentBreakpoint: newBreakpoint
          }
        }));
        _this.currentBreakpoint = newBreakpoint;
      });
    }

    _createClass(Responsive, null, [{
      key: "matchesBreakpoint",
      value: function matchesBreakpoint(breakpoint) {
        switch (breakpoint) {
          case 'phone':
            return window.matchMedia('screen and (max-width: 640px)').matches;

          case 'tablet':
            return window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches;

          case 'tablet-and-up':
            return window.matchMedia('screen and (min-width: 641px)').matches;

          case 'pocket':
            return window.matchMedia('screen and (max-width: 1007px)').matches;

          case 'lap':
            return window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches;

          case 'lap-and-up':
            return window.matchMedia('screen and (min-width: 1008px)').matches;

          case 'desk':
            return window.matchMedia('screen and (min-width: 1280px)').matches;

          case 'widescreen':
            return window.matchMedia('screen and (min-width: 1600px)').matches;

          case 'supports-hover':
            return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        }
      }
    }, {
      key: "getCurrentBreakpoint",
      value: function getCurrentBreakpoint() {
        if (window.matchMedia('screen and (max-width: 640px)').matches) {
          return 'phone';
        }

        if (window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches) {
          return 'tablet';
        }

        if (window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches) {
          return 'lap';
        }

        if (window.matchMedia('screen and (min-width: 1280px)').matches) {
          return 'desk';
        }
      }
    }]);

    return Responsive;
  }();

  var Carousel = /*#__PURE__*/function () {
    function Carousel(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var overrideSettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      _classCallCheck(this, Carousel);

      this.element = element;
      this.initialConfig = Object.assign(JSON.parse(element.getAttribute('data-flickity-config')), overrideSettings);
      this.options = options;

      this._attachListeners();

      this._build();
    }

    _createClass(Carousel, [{
      key: "destroy",
      value: function destroy() {
        this.flickityInstance.destroy();

        if (this.initialConfig['breakpoints'] !== undefined) {
          document.removeEventListener('lumos-hero:breakpoint', this._onBreakpointChangedListener);
        }
      }
    }, {
      key: "getFlickityInstance",
      value: function getFlickityInstance() {
        return this.flickityInstance;
      }
    }, {
      key: "selectCell",
      value: function selectCell(index) {
        var shouldPause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var shouldAnimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        if (shouldPause) {
          this.flickityInstance.pausePlayer();
        }

        this.flickityInstance.select(index, false, !shouldAnimate);
      }
    }, {
      key: "next",
      value: function next() {
        this.flickityInstance.next();
      }
    }, {
      key: "previous",
      value: function previous() {
        this.flickityInstance.previous();
      }
    }, {
      key: "pausePlayer",
      value: function pausePlayer() {
        this.flickityInstance.pausePlayer();
      }
    }, {
      key: "unpausePlayer",
      value: function unpausePlayer() {
        this.flickityInstance.unpausePlayer();
      }
    }, {
      key: "resize",
      value: function resize() {
        this.flickityInstance.resize();
      }
    }, {
      key: "getSelectedIndex",
      value: function getSelectedIndex() {
        return this.flickityInstance.selectedIndex;
      }
    }, {
      key: "getSelectedCell",
      value: function getSelectedCell() {
        return this.flickityInstance.selectedCell.element;
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        if (this.initialConfig['breakpoints'] !== undefined) {
          this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
          document.addEventListener('lumos-hero:breakpoint', this._onBreakpointChangedListener);
        }
      }
      /**
       * Create the carousel instance
       */

    }, {
      key: "_build",
      value: function _build() {
        var _this = this;

        var config = this._processConfig();

        this.flickityInstance = new Flickity(this.element, config);

        this._validateDraggable();

        this.selectedIndex = this.flickityInstance.selectedIndex;
        this.flickityInstance.on('resize', this._validateDraggable.bind(this));

        if (this.options['onSelect']) {
          this.flickityInstance.on('select', function () {
            // Flickity will send the "select" event whenever the window resize (even on mobile...), as a consequence we need to check
            // first if the slide index have changed or not (cf: https://github.com/metafizzy/flickity/issues/529)
            if (_this.selectedIndex !== _this.flickityInstance.selectedIndex) {
              _this.options['onSelect'](_this.flickityInstance.selectedIndex, _this.flickityInstance.selectedCell.element);

              _this.selectedIndex = _this.flickityInstance.selectedIndex;
            }
          });
        }

        if (this.options['onSettle']) {
          this.flickityInstance.on('settle', function (index) {
            _this.options['onSettle'](index, _this.flickityInstance.selectedCell.element);
          });
        }

        if (this.options['onClick']) {
          this.flickityInstance.on('staticClick', function (event, pointer, cell, index) {
            _this.options['onClick'](cell, index);
          });
        }
      }
      /**
       * By default, Flickity does not disable draggable automatically if there is nothing to slide. We therefore manually do the check here by checking
       * if the displayed elements equals to the amount of elements
       */

    }, {
      key: "_validateDraggable",
      value: function _validateDraggable() {
        var isActive = this.flickityInstance.isActive || false;

        if (!isActive || !this.flickityInstance.options['draggable']) {
          return; // Not draggable, so nothing to do
        }

        if (undefined === this.flickityInstance.selectedElements || this.flickityInstance.selectedElements.length === this.flickityInstance.cells.length) {
          this.flickityInstance.unbindDrag();
        } else {
          this.flickityInstance.bindDrag();
        }
      }
      /**
       * Flickity is a CSS driven library and hence it is hard to setup some stuff in pure JS
       */

    }, {
      key: "_processConfig",
      value: function _processConfig() {
        var config = Object.assign({}, this.initialConfig);
        delete config['breakpoints'];

        if (this.initialConfig['breakpoints'] === undefined) {
          return config; // No change, we simply return the config as it is
        }

        var breakpoints = this.initialConfig['breakpoints'];
        breakpoints.forEach(function (breakpoint) {
          if (Responsive.matchesBreakpoint(breakpoint['matches'])) {
            config = Object.assign(config, breakpoint['settings']);
          }
        });
        return config;
      }
      /**
       * Verify if the breakpoint has changed, and optionally update the carousel
       */

    }, {
      key: "_onBreakpointChanged",
      value: function _onBreakpointChanged() {
        // The breakpoint may have changed, so we delete the carousel and rebuild it
        this.flickityInstance.destroy();

        this._build();
      }
    }]);

    return Carousel;
  }();

  var Dom = /*#__PURE__*/function () {
    function Dom() {
      _classCallCheck(this, Dom);
    }

    _createClass(Dom, null, [{
      key: "getSiblings",
      value:
      /**
       * Get all the previous and next siblings, optionally filtered by a selector
       */
      function getSiblings(element, filter) {
        var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var siblings = [];
        var currentElement = element; // Do the previous first

        while (currentElement = currentElement.previousElementSibling) {
          if (!filter || currentElement.matches(filter)) {
            siblings.push(currentElement);
          }
        }

        if (includeSelf) {
          siblings.push(element);
        } // Then the next side


        currentElement = element;

        while (currentElement = currentElement.nextElementSibling) {
          if (!filter || currentElement.matches(filter)) {
            siblings.push(currentElement);
          }
        }

        return siblings;
      }
      /**
       * By default, NodeList object are only iterable with forEach on newest browsers. To support it cross-browser,
       * we need to normalize it
       */

    }, {
      key: "nodeListToArray",
      value: function nodeListToArray(nodeList, filter) {
        var items = [];

        for (var i = 0; i !== nodeList.length; ++i) {
          if (!filter || nodeList[i].matches(filter)) {
            items.push(nodeList[i]);
          }
        }

        return items;
      }
      /**
       * Calculate an element width with its margin
       */

    }, {
      key: "outerWidthWithMargin",
      value: function outerWidthWithMargin(element) {
        var width = element.offsetWidth,
            style = getComputedStyle(element);
        width += parseInt(style.marginLeft) + parseInt(style.marginRight);
        return width;
      }
      /**
       * Calculate an element height with its margin
       */

    }, {
      key: "outerHeightWithMargin",
      value: function outerHeightWithMargin(element) {
        var height = element.offsetHeight,
            style = getComputedStyle(element);
        height += parseInt(style.marginTop) + parseInt(style.marginBottom);
        return height;
      }
    }]);

    return Dom;
  }();

  var SectionContainer = /*#__PURE__*/function () {
    function SectionContainer() {
      _classCallCheck(this, SectionContainer);

      this.constructors = [];
      this.instances = [];

      this._attachListeners();
    }

    _createClass(SectionContainer, [{
      key: "_attachListeners",
      value: function _attachListeners() {
        document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
        document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
        document.addEventListener('shopify:section:select', this._onSelect.bind(this));
        document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
        document.addEventListener('shopify:section:reorder', this._onReorder.bind(this));
        document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
        document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
      }
    }, {
      key: "register",
      value: function register(type, constructor) {
        var _this = this;

        this.constructors[type] = constructor;
        Dom.nodeListToArray(document.querySelectorAll("[data-section-type=".concat(type, "]"))).forEach(function (container) {
          _this._createInstance(container, constructor);
        });
      }
      /**
       * Return an object from an array of objects that matches the provided key and value
       */

    }, {
      key: "_findInstance",
      value: function _findInstance(array, key, value) {
        for (var i = 0; i < array.length; i++) {
          if (array[i][key] === value) {
            return array[i];
          }
        }
      }
      /**
       * Remove an object from an array of objects by matching the provided key and value
       */

    }, {
      key: "_removeInstance",
      value: function _removeInstance(array, key, value) {
        var i = array.length;

        while (i--) {
          if (array[i][key] === value) {
            array.splice(i, 1);
            break;
          }
        }

        return array;
      }
    }, {
      key: "_onSectionLoad",
      value: function _onSectionLoad(event) {
        var container = event.target.querySelector('[data-section-id]');

        if (container) {
          this._createInstance(container);
        }
      }
    }, {
      key: "_onSectionUnload",
      value: function _onSectionUnload(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (!instance) {
          return;
        }

        if (typeof instance.onUnload === 'function') {
          instance.onUnload(event);
        }

        this.instances = this._removeInstance(this.instances, 'id', event.detail.sectionId);
      }
    }, {
      key: "_onSelect",
      value: function _onSelect(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (instance && typeof instance.onSelect === 'function') {
          instance.onSelect(event);
        }
      }
    }, {
      key: "_onDeselect",
      value: function _onDeselect(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (instance && typeof instance.onDeselect === 'function') {
          instance.onDeselect(event);
        }
      }
    }, {
      key: "_onReorder",
      value: function _onReorder(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (instance && typeof instance.onReorder === 'function') {
          instance.onReorder(event);
        }
      }
    }, {
      key: "_onBlockSelect",
      value: function _onBlockSelect(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (instance && typeof instance.onBlockSelect === 'function') {
          instance.onBlockSelect(event);
        }
      }
    }, {
      key: "_onBlockDeselect",
      value: function _onBlockDeselect(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (instance && typeof instance.onBlockDeselect === 'function') {
          instance.onBlockDeselect(event);
        }
      }
    }, {
      key: "_createInstance",
      value: function _createInstance(container, constructor) {
        var id = container.getAttribute('data-section-id'),
            type = container.getAttribute('data-section-type');
        constructor = constructor || this.constructors[type];

        if (typeof constructor === 'undefined') {
          return;
        }

        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });
        this.instances.push(instance);
      }
    }]);

    return SectionContainer;
  }();

  var LumosHeroSection = /*#__PURE__*/function () {
    function LumosHeroSection(container) {
      _classCallCheck(this, LumosHeroSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.controls = this.element.querySelector('[data-lumos-hero-controls]');
      var slideshowOptions = {
        onSelect: this._onSlideChanged.bind(this)
      };

      if (this.controls) {
        slideshowOptions.onSettle = this._onSlideSettled.bind(this);
      }

      this.slideshow = new Carousel(this.element.querySelector('[data-flickity-config]'), slideshowOptions);
      this.pageDots = [];
      this.progressCircle = this.controls ? this.controls.querySelector('[data-lumos-hero-progress]') : null;
      this.progressAnimation = null;
      this.isPausedByUser = false;
      this.isEditorBlockSelected = false;
      this.isPointerInteracting = false;
      this.selectedSlide = null;
      this.transitionRevision = 0;
      this.pendingSlideLoadHandler = null;
      this.isTransitionReady = true;
      this.isTransitionSettled = true;
      this.isDestroyed = false;
      this.shouldAnimate = true;
      this.timeline = new TimelineLite({
        delay: window.theme.showPageTransition ? 0.5 : 0
      });

      if (this.slideshow.flickityInstance.cells.length > 0) {
        this._transitionToSlide(this.slideshow.flickityInstance.selectedCell.element, true);
      }

      this._preparePageDots();
      this._attachListeners();
    }

    _createClass(LumosHeroSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.isDestroyed = true;
        this.transitionRevision += 1;
        this._clearPendingSlideLoadHandler();

        if (this.controls) {
          window.clearTimeout(this.playbackRestoreTimer);
          this._destroyPlaybackProgress();
          this.slideshow.flickityInstance.off('pointerDown', this._onPlaybackPointerDownListener);
          this.slideshow.flickityInstance.off('pointerUp', this._onPlaybackReleaseListener);
          this.slideshow.flickityInstance.off('pointerCancel', this._onPlaybackReleaseListener);
          this.slideshow.flickityInstance.element.removeEventListener('mouseenter', this._onCarouselMouseEnterListener);
          this.slideshow.flickityInstance.element.removeEventListener('mouseleave', this._onCarouselMouseLeaveListener);
          window.removeEventListener('scroll', this._onWindowScrollListener);
          document.removeEventListener('pointerup', this._onPlaybackReleaseListener);
          document.removeEventListener('pointercancel', this._onPlaybackReleaseListener);
          document.removeEventListener('visibilitychange', this._onVisibilityChangedListener);
        }

        this.slideshow.destroy();
        this.timeline.kill();
        this.delegateElement.off();
        document.removeEventListener('lumos-hero:breakpoint', this._onBreakpointChangedListener);
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        this.isEditorBlockSelected = true;

        if (this.controls) {
          this._restorePlaybackPreference();
        } else if (this.slideshow.flickityInstance.options.autoPlay) {
          this.slideshow.flickityInstance.stopPlayer();
        }

        this.shouldAnimate = !event.detail.load;
        this.slideshow.selectCell(event.target.getAttribute('data-slide-index'), false, !event.detail.load);

        if (event.detail.load) {
          this.isTransitionSettled = true;
        }
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect() {
        this.shouldAnimate = true;
        this.isEditorBlockSelected = false;

        if (this.controls) {
          this._restorePlaybackPreference();
        } else if (this.slideshow.flickityInstance.options.autoPlay) {
          this.slideshow.flickityInstance.playPlayer();
        }
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
        this._onPlaybackPointerDownListener = this._holdPlaybackForPointer.bind(this);
        this._onPlaybackReleaseListener = this._releasePlaybackHold.bind(this, 0);
        this._onCarouselMouseEnterListener = this._restorePlaybackPreference.bind(this);
        this._onCarouselMouseLeaveListener = this._queuePlaybackRestore.bind(this, 0);
        this._onWindowScrollListener = this._releasePlaybackHold.bind(this, 120);
        this._onVisibilityChangedListener = this._restorePlaybackPreference.bind(this);

        if (this.controls) {
          this.delegateElement.on('click', '[data-action="toggle-lumos-hero-playback"]', this._togglePlayback.bind(this));
          this.delegateElement.on('click', '[data-action="previous-lumos-hero"]', this._previousSlide.bind(this));
          this.delegateElement.on('click', '[data-action="next-lumos-hero"]', this._nextSlide.bind(this));
          this.delegateElement.on('keydown', '.flickity-page-dots .dot', this._onPageDotKeydown.bind(this));
          this.delegateElement.on('pointerdown', '.flickity-page-dots .dot', this._onPlaybackPointerDownListener);
          this.slideshow.flickityInstance.on('pointerDown', this._onPlaybackPointerDownListener);
          this.slideshow.flickityInstance.on('pointerUp', this._onPlaybackReleaseListener);
          this.slideshow.flickityInstance.on('pointerCancel', this._onPlaybackReleaseListener);
          this.slideshow.flickityInstance.element.addEventListener('mouseenter', this._onCarouselMouseEnterListener);
          this.slideshow.flickityInstance.element.addEventListener('mouseleave', this._onCarouselMouseLeaveListener);
          window.addEventListener('scroll', this._onWindowScrollListener, {
            passive: true
          });
          document.addEventListener('pointerup', this._onPlaybackReleaseListener);
          document.addEventListener('pointercancel', this._onPlaybackReleaseListener);
          document.addEventListener('visibilitychange', this._onVisibilityChangedListener);
        }

        this.delegateElement.on('click', '[data-lumos-hero-scroll]', this._scrollToContent.bind(this));
        document.addEventListener('lumos-hero:breakpoint', this._onBreakpointChangedListener);
      }
    }, {
      key: "_scrollToContent",
      value: function _scrollToContent(event, target) {
        var anchor = document.getElementById(target.getAttribute('data-lumos-hero-scroll').slice(1));
        if (!anchor) return;
        event.preventDefault();
        anchor.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      }
    }, {
      key: "_togglePlayback",
      value: function _togglePlayback(event, target) {
        this.isPausedByUser = !this.isPausedByUser;
        this._restorePlaybackPreference();
        this._syncPlaybackControl(target);
      }
    }, {
      key: "_previousSlide",
      value: function _previousSlide() {
        this.slideshow.previous();
      }
    }, {
      key: "_nextSlide",
      value: function _nextSlide() {
        this.slideshow.next();
      }
    }, {
      key: "_holdPlaybackForPointer",
      value: function _holdPlaybackForPointer() {
        this.isPointerInteracting = true;
        this._restorePlaybackPreference();
      }
    }, {
      key: "_releasePlaybackHold",
      value: function _releasePlaybackHold(delay) {
        var _this = this;

        if (!this.isPointerInteracting) {
          return;
        }

        window.clearTimeout(this.playbackRestoreTimer);
        this.playbackRestoreTimer = window.setTimeout(function () {
          _this.playbackRestoreTimer = null;

          if (_this.isDestroyed || _this.slideshow.flickityInstance.isPointerDown) {
            return;
          }

          _this.isPointerInteracting = false;
          _this._restorePlaybackPreference();
        }, delay);
      }
    }, {
      key: "_queuePlaybackRestore",
      value: function _queuePlaybackRestore(delay) {
        var _this = this;

        if (this.isDestroyed) {
          return;
        }

        window.clearTimeout(this.playbackRestoreTimer);
        this.playbackRestoreTimer = window.setTimeout(function () {
          _this.playbackRestoreTimer = null;
          _this._restorePlaybackPreference();
        }, delay);
      }
    }, {
      key: "_preparePageDots",
      value: function _preparePageDots() {
        if (!this.controls) {
          return;
        }

        this.pageDots = Dom.nodeListToArray(this.element.querySelectorAll('.flickity-page-dots .dot'));
        var labelTemplate = this.controls.getAttribute('data-dot-label-template');
        var dotCount = this.pageDots.length;

        this.pageDots.forEach(function (dot, index) {
          dot.setAttribute('role', 'button');
          dot.setAttribute('tabindex', '0');
          dot.setAttribute('aria-label', labelTemplate.replace('[[index]]', index + 1).replace('[[count]]', dotCount));
        });

        this._updatePageDots(this.slideshow.getSelectedIndex());
      }
    }, {
      key: "_restorePlaybackPreference",
      value: function _restorePlaybackPreference() {
        if (this.isDestroyed) {
          return;
        }

        var flickity = this.slideshow.flickityInstance;

        if (!flickity.options.autoPlay) {
          return;
        }

        if (this._usesPlaybackProgress()) {
          if (flickity.player.state !== 'stopped') {
            flickity.stopPlayer();
          }

          if (this._canRunPlaybackProgress()) {
            this._playPlaybackProgress();
          } else {
            this._pausePlaybackProgress();
          }

          return;
        }

        if (this.isPausedByUser || this.isEditorBlockSelected || this.isPointerInteracting || !this.isTransitionReady || !this.isTransitionSettled || document.hidden) {
          if (flickity.player.state !== 'stopped') {
            flickity.stopPlayer();
          }

          return;
        }

        if (flickity.options.pauseAutoPlayOnHover && window.matchMedia('(hover: hover)').matches && flickity.element.matches(':hover')) {
          return;
        }

        if (flickity.player.state === 'stopped') {
          flickity.playPlayer();
        } else if (flickity.player.state === 'paused') {
          flickity.unpausePlayer();
        }
      }
    }, {
      key: "_usesPlaybackProgress",
      value: function _usesPlaybackProgress() {
        return !!(this.controls && this.progressCircle && typeof this.progressCircle.animate === 'function');
      }
    }, {
      key: "_canRunPlaybackProgress",
      value: function _canRunPlaybackProgress() {
        var flickity = this.slideshow.flickityInstance,
            isHovering = flickity.options.pauseAutoPlayOnHover && window.matchMedia('(hover: hover)').matches && flickity.element.matches(':hover');

        return !this.isPausedByUser && !this.isEditorBlockSelected && !this.isPointerInteracting && this.isTransitionReady && this.isTransitionSettled && !document.hidden && !isHovering;
      }
    }, {
      key: "_getPlaybackDuration",
      value: function _getPlaybackDuration() {
        var autoPlay = this.slideshow.flickityInstance.options.autoPlay,
            duration = Number(autoPlay);

        return isFinite(duration) && duration > 0 ? duration : 0;
      }
    }, {
      key: "_resetPlaybackProgress",
      value: function _resetPlaybackProgress() {
        var _this2 = this;

        this._destroyPlaybackProgress();

        if (!this._usesPlaybackProgress()) {
          return;
        }

        var duration = this._getPlaybackDuration();

        if (!duration) {
          return;
        }

        this.progressCircle.style.strokeDashoffset = '100';
        var animation = this.progressCircle.animate([{
          strokeDashoffset: '100'
        }, {
          strokeDashoffset: '0'
        }], {
          duration: duration,
          easing: 'linear',
          fill: 'forwards'
        });
        animation.pause();
        animation.currentTime = 0;
        animation.onfinish = function () {
          _this2._onPlaybackProgressFinished(animation);
        };
        this.progressAnimation = animation;
      }
    }, {
      key: "_destroyPlaybackProgress",
      value: function _destroyPlaybackProgress() {
        if (!this.progressAnimation) {
          return;
        }

        this.progressAnimation.onfinish = null;
        this.progressAnimation.cancel();
        this.progressAnimation = null;
      }
    }, {
      key: "_pausePlaybackProgress",
      value: function _pausePlaybackProgress() {
        if (this.progressAnimation && this.progressAnimation.playState === 'running') {
          this.progressAnimation.pause();
        }
      }
    }, {
      key: "_playPlaybackProgress",
      value: function _playPlaybackProgress() {
        if (!this.progressAnimation) {
          this._resetPlaybackProgress();
        }

        if (!this.progressAnimation) {
          return;
        }

        if (this.progressAnimation.playState === 'finished') {
          this._onPlaybackProgressFinished(this.progressAnimation);
          return;
        }

        this.progressAnimation.play();
      }
    }, {
      key: "_onPlaybackProgressFinished",
      value: function _onPlaybackProgressFinished(animation) {
        if (this.isDestroyed || animation !== this.progressAnimation || !this._canRunPlaybackProgress()) {
          return;
        }

        this._destroyPlaybackProgress();
        this.slideshow.next();
      }
    }, {
      key: "_syncPlaybackControl",
      value: function _syncPlaybackControl(target) {
        if (!target) {
          return;
        }

        target.classList.toggle('is-paused', this.isPausedByUser);
        target.setAttribute('aria-label', target.getAttribute(this.isPausedByUser ? 'data-play-label' : 'data-pause-label'));
      }
    }, {
      key: "_updatePageDots",
      value: function _updatePageDots(selectedIndex) {
        this.pageDots.forEach(function (dot, index) {
          if (index === selectedIndex) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }, {
      key: "_onPageDotKeydown",
      value: function _onPageDotKeydown(event, target) {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }

        event.preventDefault();
        var targetIndex = this.pageDots.indexOf(target);

        if (targetIndex !== -1) {
          this.slideshow.selectCell(targetIndex);
          this._restorePlaybackPreference();
        }
      }
    }, {
      key: "_onSlideChanged",
      value: function _onSlideChanged(index, element) {
        if (this.isDestroyed) {
          return;
        }

        this._resetPlaybackProgress();
        this._updatePageDots(index);
        this._transitionToSlide(element);
      }
    }, {
      key: "_onSlideSettled",
      value: function _onSlideSettled() {
        if (this.isDestroyed) {
          return;
        }

        this.isTransitionSettled = true;

        if (this.controls) {
          this._restorePlaybackPreference();
        }
      }
    }, {
      key: "_clearPendingSlideLoadHandler",
      value: function _clearPendingSlideLoadHandler() {
        if (!this.pendingSlideLoadHandler) {
          return;
        }

        this.pendingSlideLoadHandler.image.removeEventListener('lazyloaded', this.pendingSlideLoadHandler.handler);
        this.pendingSlideLoadHandler = null;
      }
    }, {
      key: "_normalizeSlidesForTransition",
      value: function _normalizeSlidesForTransition(nextSlide) {
        var previousSlide = this.selectedSlide;

        this.slideshow.flickityInstance.cells.forEach(function (cell) {
          if (cell.element !== nextSlide && cell.element !== previousSlide) {
            cell.element.style.opacity = '0';
            cell.element.style.visibility = 'hidden';
          }
        });
      }
    }, {
      key: "_enterSlideForRevision",
      value: function _enterSlideForRevision(slide, revision) {
        if (this.isDestroyed || revision !== this.transitionRevision || slide !== this.selectedSlide) {
          return;
        }

        this.isTransitionReady = true;
        this._clearPendingSlideLoadHandler();
        this._slideEnter(slide);
      }
    }, {
      key: "_transitionToSlide",
      value: function _transitionToSlide(slide, isAlreadySettled) {
        if (!this.controls) {
          this._transitionToSlideWithoutControls(slide);
          return;
        }

        var _this = this;

        this._clearPendingSlideLoadHandler();
        this.transitionRevision += 1;
        var transitionRevision = this.transitionRevision;
        this.isTransitionReady = false;
        this.isTransitionSettled = !!isAlreadySettled;
        this._restorePlaybackPreference();
        this.timeline.clear();
        this._normalizeSlidesForTransition(slide);

        if (this.selectedSlide) {
          this._slideLeave(this.selectedSlide);

          this.timeline.addLabel('enter', this.shouldAnimate ? '-=0.4' : 0);
        } // We get the next slide (if any) to preload it


        this._lazyLoadNextImage();

        this.timeline.fromTo(slide, this.selectedSlide && this.shouldAnimate ? 0.3 : 0, {
          autoAlpha: 0
        }, {
          autoAlpha: 1,
          ease: Cubic.easeInOut
        }, 'enter'); // The image may take 1s or more to load depending on the network, so we make sure to pause the player, and restart it once it has transitioned

        if (this.slideshow.flickityInstance.options.autoPlay) {
          this.slideshow.flickityInstance.stopPlayer();
        }

        this.selectedSlide = slide;
        var activeImage = this._getActiveSlideImage(slide);

        if (activeImage && (activeImage.classList.contains('Image--lazyLoading') || activeImage.classList.contains('Image--lazyLoad'))) {
          var handler = function handler() {
            activeImage.removeEventListener('lazyloaded', handler);
            _this.pendingSlideLoadHandler = null;
            _this._enterSlideForRevision(slide, transitionRevision);
          };

          this.pendingSlideLoadHandler = {
            image: activeImage,
            handler: handler
          };
          activeImage.addEventListener('lazyloaded', handler);
        } else {
          this._enterSlideForRevision(slide, transitionRevision);
        }
      }
    }, {
      key: "_transitionToSlideWithoutControls",
      value: function _transitionToSlideWithoutControls(slide) {
        var _this2 = this;

        this.timeline.clear();

        if (this.selectedSlide) {
          this._slideLeave(this.selectedSlide);
          this.timeline.addLabel('enter', this.shouldAnimate ? '-=0.4' : 0);
        }

        this._lazyLoadNextImage();
        this.timeline.fromTo(slide, this.selectedSlide && this.shouldAnimate ? 0.3 : 0, {
          autoAlpha: 0
        }, {
          autoAlpha: 1,
          ease: Cubic.easeInOut
        }, 'enter');

        if (this.slideshow.flickityInstance.options.autoPlay && this.slideshow.flickityInstance.player.state === 'playing') {
          this.slideshow.flickityInstance.pausePlayer();
        }

        Dom.nodeListToArray(slide.querySelectorAll('.LumosHero__Image')).forEach(function (image) {
          if (image.classList.contains('Image--lazyLoading') || image.classList.contains('Image--lazyLoad')) {
            image.addEventListener('lazyloaded', _this2._slideEnter.bind(_this2, slide));
          } else {
            _this2._slideEnter(slide);
          }
        });
        this.selectedSlide = slide;
      }
    }, {
      key: "_getActiveSlideImage",
      value: function _getActiveSlideImage(slide) {
        var imageContainers = Dom.nodeListToArray(slide.querySelectorAll('.LumosHero__ImageContainer'));

        for (var index = 0; index < imageContainers.length; index++) {
          if (window.getComputedStyle(imageContainers[index]).display !== 'none') {
            return imageContainers[index].querySelector('.LumosHero__Image');
          }
        }

        return null;
      }
    }, {
      key: "_slideLeave",
      value: function _slideLeave(slide) {
        var content = slide.querySelector('.SectionHeader'),
            buttonWrapper = slide.querySelector('.SectionHeader__ButtonWrapper');
        this.timeline.fromTo(slide, this.shouldAnimate ? 0.3 : 0, {
          autoAlpha: 1
        }, {
          autoAlpha: 0,
          ease: Cubic.easeInOut,
          delay: this.shouldAnimate ? 0.35 : 0
        });

        if (content) {
          this.timeline.fromTo(content, this.shouldAnimate ? 0.4 : 0, {
            autoAlpha: 1,
            y: 0
          }, {
            autoAlpha: 0,
            y: 20,
            ease: Cubic.easeIn
          }, 0);
        }

        if (buttonWrapper) {
          this.timeline.fromTo(buttonWrapper, this.shouldAnimate ? 0.4 : 0, {
            autoAlpha: 1,
            y: 0
          }, {
            autoAlpha: 0,
            y: 10,
            ease: Cubic.easeIn
          }, 0);
        }
      }
    }, {
      key: "_slideEnter",
      value: function _slideEnter(slide) {
        var images = slide.querySelectorAll('.LumosHero__Image'),
            content = slide.querySelector('.SectionHeader'),
            buttonWrapper = slide.querySelector('.SectionHeader__ButtonWrapper');

        if (this.controls) {
          this._restorePlaybackPreference();
        } else if (this.slideshow.flickityInstance.options.autoPlay && this.slideshow.flickityInstance.player.state === 'paused') {
          this.slideshow.flickityInstance.unpausePlayer();
        }

        if (window.CSS && window.CSS.supports('(object-fit: cover) or (-o-object-fit: cover)')) {
          if (window.theme.showImageZooming) {
            this.timeline.fromTo(images, this.shouldAnimate ? 1.2 : 0, {
              opacity: 0,
              scale: 1.2
            }, {
              opacity: 1,
              scale: 1,
              ease: Quad.easeOut
            }, 'enter');
          } else {
            this.timeline.fromTo(images, this.shouldAnimate ? 1.2 : 0, {
              opacity: 0
            }, {
              opacity: 1,
              ease: Quad.easeOut
            }, 'enter');
          }
        }

        if (content) {
          this.timeline.fromTo(content, this.shouldAnimate ? 0.8 : 0, {
            autoAlpha: 0,
            y: 30
          }, {
            autoAlpha: 1,
            y: 0,
            delay: this.shouldAnimate ? 0.8 : 0,
            ease: Cubic.easeOut
          }, 'enter');
        }

        if (buttonWrapper) {
          this.timeline.fromTo(buttonWrapper, this.shouldAnimate ? 0.8 : 0, {
            autoAlpha: 0,
            y: 20
          }, {
            autoAlpha: 1,
            y: 0,
            delay: this.shouldAnimate ? 0.8 : 0,
            ease: Cubic.easeOut
          }, 'enter');
        }
      }
    }, {
      key: "_lazyLoadNextImage",
      value: function _lazyLoadNextImage() {
        var currentIndex = this.slideshow.flickityInstance.selectedIndex,
            breakpoint = Responsive.getCurrentBreakpoint();

        if (this.slideshow.flickityInstance.cells.length - 1 > currentIndex) {
          var nextCellElement = this.slideshow.flickityInstance.cells[currentIndex + 1].element,
              imageContainers = Dom.nodeListToArray(nextCellElement.querySelectorAll('.LumosHero__ImageContainer')),
              imageToReveal = null;

          if (breakpoint === 'phone') {
            imageToReveal = imageContainers[0];
          } else {
            imageToReveal = imageContainers[1];
          }

          if (window.lazySizes && imageToReveal && imageToReveal.classList.contains('Image--lazyLoad')) {
            lazySizes.loader.unveil(imageToReveal.firstElementChild);
          }
        }
      }
    }, {
      key: "_onBreakpointChanged",
      value: function _onBreakpointChanged(event) {
        if (this.isDestroyed) {
          return;
        }

        this._preparePageDots();

        if (event.detail.previousBreakpoint === 'phone' && event.detail.currentBreakpoint !== 'phone' || event.detail.previousBreakpoint !== 'phone' && event.detail.currentBreakpoint === 'phone') {
          this.selectedSlide = null;

          this._transitionToSlide(this.slideshow.flickityInstance.selectedElement, true);
        }
      }
    }]);

    return LumosHeroSection;
  }();

  new Responsive();
  var sections = new SectionContainer();
  sections.register('lumos-hero', LumosHeroSection);
  window.__lumosHeroSections = sections;
}());
